"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const RightsholderSubNavigationMobile_1 = __importDefault(require("@Components/RightsholderSubNavigationMobile"));
const RightsholderSubNavigation_1 = __importDefault(require("@Components/RightsholderSubNavigation"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const RightsholderLayout = () => {
    const { rightsholderStore, catalogSearchStore, userStore, rightsholderUserStore, uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const params = (0, react_router_dom_1.useParams)();
    (0, react_1.useEffect)(() => {
        getData().then();
    }, [params.rightsholderId]);
    (0, react_1.useEffect)(() => () => {
        catalogSearchStore.resetStore();
        rightsholderUserStore.destroyRightsHolderUserToAbility();
        rightsholderStore.destroyRightsholder();
    }, []);
    const getUserForRightsHolderToAbility = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const currentUserId = (_a = userStore.userInfo) === null || _a === void 0 ? void 0 : _a.id;
        if (currentUserId) {
            yield rightsholderUserStore.loadRightsholderUserToAbility(currentUserId);
        }
    });
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield rightsholderStore.setCurrentRightsholderId(Number(params.rightsholderId));
        yield getUserForRightsHolderToAbility();
        setLoading(false);
    });
    return rightsholderStore.optionalMemberSummary && rightsholderStore.optionalCurrentRightsholderId ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Member' }),
        react_1.default.createElement("main", { className: "rightsholder-scene" }, loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            uiStore.isMobile ? react_1.default.createElement(RightsholderSubNavigationMobile_1.default, null) : react_1.default.createElement(RightsholderSubNavigation_1.default, null),
            react_1.default.createElement("div", { className: 'rightsholder-switch-container' },
                react_1.default.createElement("div", { className: 'global-container' },
                    react_1.default.createElement(react_router_dom_1.Outlet, null)))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = (0, mobx_react_1.observer)(RightsholderLayout);
